import React, { useContext } from "react";
import "../index.css";
import { MDBCol, MDBRow, MDBBtn } from "mdbreact";
import { Link } from "react-router-dom";

import {useHistory} from "react-router-dom";

const Frontpage = () => {
 
  let history = useHistory();

  const renderToBookshelf = ()=>{
    history.push("/show");
  }

  return (
    <div
      className="bg"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        zIndex: 10,
        boxShadow: "5ps 5ps 8px pink"
      }}
    >
      <Link to={"/sort/popular"} className="link">
        {" "}
        <h1 className="title" style={{}}>
      Movies...
        </h1>
      </Link>
     
    </div>
  );
};
export default Frontpage;
